const OPERATORS = {
  PAGE_TITLE: 'Operators | Raychat',

  HEADING_TITLE: 'Operators',
  HEADING_SUBTITLE:
    'While viewing the total hours and the number of calls accepted by the operators, you can apply your desired changes in the operator settings section, add a new operator and delete some operators.',
  ADD_OPERATOR: 'Add New Operator',

  WEEKLY_CHOSEN_OPERATOR: 'Weekly Chosen Operator',
  WORKING_HOURS: 'Working Hours',
  ACCEPTED_CONVS: 'Accepted Conversations',
  ACCEPTED: 'Accepted',
  OPERATORS_SETTINGS: 'Operator Settings',
  PROFILE_SETTINGS: 'Profile Settings',
  DELETE_OPERATOR: 'Delete Operator',
  DELETE_OPERATOR_CONFIRM:
    'Do you confirm that #name# will be removed from your list of operators?',

  OPERATORS_LSIT: 'Operators List',

  OPERATOR: 'Operator',

  USER_PROFILE: 'User Profile',
  ADMIN: 'Admin',

  OPERATOR_MODAL_AVATAR_HINT:
    'The size of the image should be 60 x 60 pixels and in png format.',
  OPERATOR_MODAL_AVATAR_UPLOAD_IMAGE: 'Upload Image',
  OPERATOR_MODAL_AVATART_DELETE_IMAGE: 'Delete Image',

  OPERATOR_MODAL_FORM_TITLE: 'Title',
  OPERATOR_MODAL_FORM_FULLNAME: 'Fullname',
  OPERATOR_MODAL_FORM_EMAIL: 'Email',
  OPERATOR_MODAL_FORM_PASSWORD: 'Password',
  OPERATOR_MODAL_FORM_PASSWORD_CONFIRM: 'Password Repeat',

  OPERATOR_MODAL_WEBSITES_LIST_TITLE:
    'The operator has access to these websites:',
  OPERATOR_MODAL_ACCESS_LEVEL: 'Access level:',

  OPERATOR_MODAL_CANCEL: 'Cancel',
  OPERATOR_MODAL_ADD: 'Add Operator',
  OPERATOR_MODAL_SAVE_CHANGES: 'Save Changes',
  OPERATOR_MODAL_SEND_CONFIRM_CODE: 'Send Code',

  OVERLAY_TEXT:
    'This part is not available in the free package. Upgrade your package to use it.',
  OVERLAY_CLOSE: 'Close',

  OPERATOR_WITHOUT_TITLE_LABEL: 'No Title',
};

export default OPERATORS;
